<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.reservation.actions.confirm.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="pt-4 text-left">
      <o-field-group>
        <checkbox-field v-model="sendMail" :label="$t('general.sendEmail')" :info="$t('reservation.sendEmailInfo')" />
      </o-field-group>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import {
  CheckboxField,
} from '@/components/fields'

import type { Reservation } from '~/_api/models/reservation'

interface Props {
  reservation: Reservation
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'update:reservation', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $auth, $bus } = useNuxtApp()

const dialog = ref<any>()
const sendMail = ref(false)

const info = computed(() => {
  return $i18n.t('components.reservation.actions.confirm.info', { label: (props.reservation as any).infoLabel || (props.reservation as any).reservation?.infoLabel })
})

const open = () => {
  sendMail.value = ($auth as any).info?.location?.sendInternalReservationConfirmNotifications

  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.reservation.confirm(
      props.reservation.objectID()!,
      { sendEmail: sendMail.value }
    )

    if (response.data) {
      emit('update:reservation', response.data)
      emit('update:loading', false)

      $bus.emit.updated('Reservation', response.data)

      $notification.toast({
        title: $i18n.t('reservation.confirmed'),
        text: $i18n.t('reservation.confirmSuccessInfo', { name: (props.reservation as any).customer.displayName }),
      })

      return true
    }
  } catch (e: any) {
    console.log(e)
  }
}

defineExpose({
  open,
})
</script>
